<goab-table width="100%" variant="normal">
  <thead>
    <tr>
      <th width="64%">Bed type</th>
      <th width="18%">Funded beds</th>
      <th width="18%">Empty beds</th>
    </tr>
  </thead>
  <tbody>
    @for (facilityBed of facilityBeds(); track $index; let i = $index) {
    <tr [ngClass]="{ 'shaded-row': i % 2 === 0 }">
      <td>
        <goab-text #bedTypeTextHeading tag="h3" size="body-m" mt="none" mb="none"
          ><span class="bold-text"
            >Type {{ facilityBed.bedType }}</span
          ></goab-text
        >
        <goab-text
          #bedTypesubTextHeading
          tag="h4"
          size="body-s"
          mt="none"
          mb="none"
          ><span class="bold-text"
            >Formerly {{ facilityBed.formerly }}:</span
          ></goab-text
        >
        <goab-text
          #bedTypeDescriptionHeading
          size="body-xs"
          tag="span"
          mt="none"
          mb="none"
          >{{ facilityBed.description }}</goab-text
        >
      </td>
      <td>{{ facilityBed.fundedBedCount }}</td>
      <td>
        <app-facility-beds-entry-row
          [bedType]="facilityBed.bedType"
          [displayFor]="'hasEmptyBeds'"
        ></app-facility-beds-entry-row>
      </td>
    </tr>
    <tr *ngIf="resolveHasEmptyReasonsFlagForRow(facilityBed.bedType)">
      <td colspan="3">
        <app-facility-beds-entry-row
          [bedType]="facilityBed.bedType"
          [displayFor]="'emptyBedReasons'"
        ></app-facility-beds-entry-row>
      </td>
    </tr>
    }
  </tbody>
</goab-table>
